'use client';

import { type ReactNode, useRef } from 'react';
import { useScrolledUnder } from '@/hooks';

interface PageLeadActionProps {
    children: ReactNode;
}

/**
 * Marks the page's lead action, the first button of the hero that opens the
 * page. While it is in view below the header, the header holds its own action
 * button back; once it has scrolled under the bar, the header's button takes
 * over (`header.css`). The marker lives on the page, so it comes and goes with
 * it and the persistent header needs no page data. Pages without one show the
 * header's button from the first paint.
 */
function PageLeadAction({ children }: PageLeadActionProps) {
    const ref = useRef<HTMLSpanElement>(null);
    const isUnderHeader = useScrolledUnder(ref, '.site-header');

    return (
        <span ref={ref} className="flex" data-page-lead-action="" data-under-header={isUnderHeader}>
            {children}
        </span>
    );
}

export default PageLeadAction;
